import { Col, Form, FormProps, Input, Row } from 'antd';
import { ICompany } from 'interfaces/companies';
import { InputMask } from 'components/form-items/InputMask';

interface CompanyFormProps {
  formProps: FormProps<ICompany>;
}

export const CompanyForm = ({ formProps }: CompanyFormProps) => {
  const dashPattern = /[-\u2013]/;
  const addressFinalPattern = /[-\u2013]\s*[A-Za-zÀ-ÿ\s]+\/[A-Z]{2}$/;
  return (
    <Form {...formProps} layout="vertical">
      <Form.Item
        label="Nome da unidade"
        name="name"
        rules={[
          {
            required: true
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Form.Item
            label="CNPJ"
            name="cnpj"
            rules={[
              {
                required: true
              }
            ]}
          >
            <InputMask mask="00.000.000/0000-00" />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item label="Inscrição municipal" name="city_registration">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item label="Inscrição estadual" name="state_registration">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={6}>
          <Form.Item
            label="CEP"
            name="zipcode"
            rules={[
              {
                required: true
              }
            ]}
          >
            <InputMask mask="00.000-000" />
          </Form.Item>
        </Col>

        <Col xs={24} md={18}>
          <Form.Item
            label={
              <span>
                Endereço{' '}
                <span style={{ color: '#8c8c8c', fontWeight: 400 }}>
                  Informe: Logradouro, nº - Bairro - Cidade/UF
                </span>
              </span>
            }
            name="address"
            rules={[
              {
                required: true,
                message: 'Campo obrigatório'
              },
              {
                validator: (_, value: string) => {
                  if (!value) return Promise.resolve();

                  const hasDash = dashPattern.test(value);
                  const hasCityUfAtEnd = addressFinalPattern.test(value.trim());

                  if (!hasDash || !hasCityUfAtEnd) {
                    return Promise.reject(
                      new Error(
                        'Use o formato: Logradouro, nº - Bairro - Cidade/UF'
                      )
                    );
                  }

                  return Promise.resolve();
                }
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Form.Item
            label="Nome do responsável"
            name="responsible_name"
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            label="E-mail do responsável"
            name="responsible_email"
            rules={[
              {
                type: 'email',
                message: 'Email incorreto'
              }
            ]}
          >
            <Input type="email" />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item label="Telefone do responsável" name="phone_number">
            <InputMask mask="(00) [0]0000-0000" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label={
          <span>
            Informações adicionais{' '}
            <span style={{ color: '#8c8c8c', fontWeight: 400 }}>
              Informe o código e-MEC da Unidade (ex: 00000)
            </span>
          </span>
        }
        name="notes"
        rules={[
          {
            required: true,
            message: 'Campo obrigatório'
          }
        ]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
    </Form>
  );
};
